import "./DragButton.scss"
import IconDrag from "assets/img/icon-drag.svg?react"

import { FC } from "react"
import { DraggableProvidedDragHandleProps } from "@hello-pangea/dnd"

interface IDragButtonProps {
    dragHandleProps: DraggableProvidedDragHandleProps | null | undefined
    disabled?: boolean
}

const DragButton: FC<IDragButtonProps> = ({
    dragHandleProps,
    disabled,
}) => {
    return (
        <button
            {...dragHandleProps}
            className="drag-button"
            disabled={disabled}
            data-testid="drag-button">
            <IconDrag />
        </button>
    )
}

export default DragButton
